"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var helpers_1 = require("../helpers");
var getElementParentOffset = function (el, parentEl) {
    var rtl = (0, helpers_1.isRTL)();
    var offset = rtl
        ? parentEl.clientWidth - el.offsetLeft - el.clientWidth
        : el.offsetLeft;
    return Math.ceil(offset);
};
exports.default = getElementParentOffset;
